import React, { useState } from 'react'
import { useResume } from '../ResumeProvider'
import { Button } from '~/lib/ui/button'
import { PlusIcon } from '@heroicons/react/24/outline'
import { EditableHeading, newKey } from './common'
import EmploymentItem from './EmploymentItem'
import { EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const EmploymentEditor = () => {
  const { t } = useTranslation('EmploymentEditor')
  const { resumeDocument, setResumeDocument } = useResume()
  const [activeIndex, setActiveIndex] = useState(-1)
  const work = resumeDocument?.work || []

  const addEmployment = () => {
    const newIndex = work?.length || 0
    const updatedWork = [...work, {}]

    setResumeDocument({ ...resumeDocument, work: updatedWork })
    setActiveIndex(newIndex)
  }

  return (
    <div className="flex flex-col">
      <div className="mb-4 flex flex-row">
        <EditableHeading
          title={t('work_experience')}
          description={t('work_experience_description')}
          settingName="workHeading"
        />
      </div>
      <div className="pb-4 tracking-[0.024px]">
        {t('work_experience_instructions')}
      </div>
      {work.map((employment, index) => {
        employment.key = employment.key || newKey()
        return (
          <div key={employment.key}>
            <EditorItemProvider
              sectionName="work"
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              item={employment}
            >
              <EmploymentItem />
            </EditorItemProvider>
          </div>
        )
      })}
      <Button onClick={addEmployment} className="max-w-min">
        {t('add_employment')}
        <PlusIcon className="ml-2 w-5" />
      </Button>
    </div>
  )
}
export default EmploymentEditor
